
// Fix IE11
import 'babel-polyfill'
import 'whatwg-fetch'

import Vue from 'vue'
import VueRouter from 'vue-router'
import VueYouTubeEmbed from 'vue-youtube-embed'


import CoreEmit from './core/core-emit'
import CoreDragArea from './core/core-drag-area'
import CoreVideoPlayer from './core/core-video-player'
import AppHeader from './components/app-header'
import AppSubscribe from './components/app-subscribe'
import AppPopinWatch from './components/app-popin-watch'
import AppMenu from './components/app-menu'
import AppMenuButton from './components/app-menu-button'
import AppLoader from './components/app-loader'
import AppLogo from './components/app-logo'
import AppLogoAnim from './components/app-logo-anim'
import AppFooter from './components/app-footer'
import AppCircleArrow from './components/app-circle-arrow'
import AppScrollObject from './components/app-scroll-object'
import AppVideoPlayer from './components/app-video-player'
import AppVideoSkinSimple from './components/app-video-skin-simple'
import AppPageNavBottom from './components/app-page-nav-bottom'
import App3DClimb from './components/app-3d-climb'
import App3DWalk from './components/app-3d-walk'
import App3DRock from './components/app-3d-rock'
import AppLink from './components/app-link'
import AppPageBgIntro from './components/app-page-bg-intro'
import AppButtonWatch from './components/app-button-watch'

import Page404 from './pages/page-404'
import PageBook from './pages/page-book'
import PageExercice from './pages/page-exercice'
import PageHome from './pages/page-home'
import PageLanding from './pages/page-landing'
import PageNutrition from './pages/page-nutrition'
import PagePsychology from './pages/page-psychology'









Vue.use(VueYouTubeEmbed)
Vue.use(VueRouter)

// Vue.component('core-ajax', CoreAjax)
Vue.component('core-drag-area', CoreDragArea)
Vue.component('core-emit', CoreEmit)
Vue.component('core-video-player', CoreVideoPlayer)
Vue.component('app-header', AppHeader)
Vue.component('app-subscribe', AppSubscribe)
Vue.component('app-popin-watch', AppPopinWatch)
Vue.component('app-menu', AppMenu)
Vue.component('app-menu-button', AppMenuButton)
Vue.component('app-loader', AppLoader)
Vue.component('app-logo', AppLogo)
Vue.component('app-logo-anim', AppLogoAnim)
Vue.component('app-footer', AppFooter)
Vue.component('app-circle-arrow', AppCircleArrow)
Vue.component('app-scroll-object', AppScrollObject)
Vue.component('app-video-player', AppVideoPlayer)
Vue.component('app-video-skin-simple', AppVideoSkinSimple)
Vue.component('app-page-nav-bottom', AppPageNavBottom)
Vue.component('app-3d-climb', App3DClimb)
Vue.component('app-3d-walk', App3DWalk)
Vue.component('app-3d-rock', App3DRock)
Vue.component('app-link', AppLink)
Vue.component('app-page-bg-intro', AppPageBgIntro)
Vue.component('app-button-watch', AppButtonWatch)

Vue.component('page-404', Page404)
Vue.component('page-book', PageBook)
Vue.component('page-exercice', PageExercice)
Vue.component('page-home', PageHome)
Vue.component('page-landing', PageLanding)
Vue.component('page-nutrition', PageNutrition)
Vue.component('page-psychology', PagePsychology)





import Application from './application'


new Vue({
    el: '#application',
    render: h => h(Application)
})
